var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none}.prefix__cls-2{fill:#fff;stroke:#3063d5;stroke-width:1.6px}.prefix__cls-3{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__total",
    transform: "translate(-386 -382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2272",
    d: "M0 0H40V40H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 2272",
    transform: "translate(386 382)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_1196",
    className: "prefix__cls-2",
    "data-name": "Ellipse 1196",
    transform: "translate(389 408)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    className: "prefix__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 4.7,
    className: "prefix__cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_1197",
    className: "prefix__cls-2",
    "data-name": "Ellipse 1197",
    transform: "translate(401 408)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    className: "prefix__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 4.7,
    className: "prefix__cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_1200",
    className: "prefix__cls-2",
    "data-name": "Ellipse 1200",
    transform: "translate(395 396)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    className: "prefix__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 4.7,
    className: "prefix__cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_1201",
    className: "prefix__cls-2",
    "data-name": "Ellipse 1201",
    transform: "translate(401 384)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    className: "prefix__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 4.7,
    className: "prefix__cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_1198",
    className: "prefix__cls-2",
    "data-name": "Ellipse 1198",
    transform: "translate(413 408)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    className: "prefix__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 4.7,
    className: "prefix__cls-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_1199",
    className: "prefix__cls-2",
    "data-name": "Ellipse 1199",
    transform: "translate(407 396)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    className: "prefix__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 4.7,
    className: "prefix__cls-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAccounts);
export default __webpack_public_path__ + "static/media/total-accounts.8ee4cb45949e99ea74374a31128c7091.svg";
export { ForwardRef as ReactComponent };